import axios from 'axios';
const server = process.env.REACT_APP_SERVER_URL;

export const registerProperty = async (data, token) => {
  try {
    const response = await axios.post(`${server}/estates/sedemat`, data,{ headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getProperty = async (code, token) => {
  try {
    const response = await axios.get(`${server}/estates/sedemat/?codCat=${code}`,{ headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const editProperty = async (data, token) => {
  try {
    const response = await axios.patch(`${server}/estates/sedemat/estate`, data, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    throw error;
  }
}